module.exports = __webpack_public_path__ + "static/media/vacation-with-friends-mob.d27a1b8b.jpg";